// extracted by mini-css-extract-plugin
var _1 = "fullHeight__ioGoX";
var _2 = "page__R0MC_";
var _3 = "pageContent__eaWeT";
export { _1 as "fullHeight", _2 as "page", _3 as "pageContent" }
